module.exports = __webpack_public_path__ + "img/home_icon_qita_sel.7068c8cb.png";